export default "__VITE_ASSET__CoA8JUlf__"